"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconIncrediblePerformance = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.144 8.42a.75.75 0 011.256.812l-.06.093-4.012 5.304a.75.75 0 01-1.257-.812l.06-.093 4.013-5.304z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4.252c6.487 0 11.746 5.259 11.746 11.746a.75.75 0 01-1.5 0c0-5.659-4.587-10.246-10.246-10.246-5.659 0-10.246 4.587-10.246 10.246a.75.75 0 01-1.5 0C.254 9.511 5.513 4.252 12 4.252z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 12.998a3 3 0 110 6 3 3 0 010-6zm0 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconIncrediblePerformance, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;